import React, { useState, useEffect, useRef, useContext } from "react";
import UserNavbar from "./userNavbar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Bars } from "react-loader-spinner";
import Filtericon from "../../assets/filter.png";
// import { Space } from "antd";
import UserTable from "./userTable";
import savedicon from "../../assets/Bookmark.png";
import { FaSearch } from "react-icons/fa";
// import { TbFileDescription } from "react-icons/tb";
import chatbox from "../../assets/chatbox.png";
import { DatePicker } from "antd";
import logout_eye_btn from "../../assets/IBUTTON.png";
import hamburger from "../../assets/slide_left.png";
import hamburger1 from "../../assets/slide_right.png";
import refresh_icon from "../../assets/refresh.png";
import today_img_icon from "../../assets/today.png";
import today_img_icon_active from "../../assets/today_active.png";

import filter_icon from "../../assets/uil_calender.png";
import yesterday_img_icon from "../../assets/yesterday.png";
import yesterday_img_icon_active from "../../assets/yesterday_active.png";

import tomorrow_img_icon from "../../assets/tomorrow.png";
import tomorrow_img_icon_active from "../../assets/tomorrow_active.png";
import next7days_img_icon from "../../assets/next_7_days.png";
import next7days_img_icon_active from "../../assets/next_7_days_active.png";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import styles from "../tradeall.module.css";
import { DownOutlined } from "@ant-design/icons";
// import Select, { SelectChangeEvent } from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import live_trade_icon from "../../assets/candlestick-chart.png";
// <----mobile icon---->
import next7days_img_icon_active_m from "../../assets/active_next_7_days_m.png";
import yesterday_img_icon_m from "../../assets/yesterday_m.png";
import yesterday_img_icon_active_m from "../../assets/active_yesterday_m.png";

import tomorrow_img_icon_m from "../../assets/tomorrow_m.png";
import tomorrow_img_icon_active_m from "../../assets/active_tomorrow_m.png";
import next7days_img_icon_m from "../../assets/next_7_days_m.png";
import today_img_icon_m from "../../assets/today_m.png";
import today_img_icon_active_m from "../../assets/active_today_m.png";
import filtericondate from "../../assets/filtericon.png";
import { MdDateRange } from "react-icons/md";
import loaderGif from "../../assets/loading.gif";
import compareTable_btn from "../../assets/compare.png";
import empty_checkbox from "../../assets/twitter.png";
import { Select, Space } from "antd";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { FaRegClock } from "react-icons/fa";
import Timezonedropdown from "../Timezonedropdown";
import { TimezoneContext } from "../../context/TimezoneContext";
import { timezones } from "../../context/TimezoneContext";
import { DateTime } from "luxon";



// const { RangePicker } = DatePicker;
const { RangePicker } = DatePicker;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const countries = [
  "UK",
  "US",
  "CA",
  "CH",
  "EU",
  "JP",
  "AU",
  "NZ",
  "DE",
  "IT",
  "FR",
];

const UserCalender = () => {
  const dropdownRef = useRef(null);
  const { selectedZone, setSelectedZone } = useContext(TimezoneContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [clickedon, setclickedon] = useState("today");
  const [errorMessage, setErrorMessage] = useState("");
  const [maindata, setmaindata] = useState([]);
  // const [clickedend, setclickedend] = useState("todaydata");
  const [loading, setLoading] = useState(true);
  const [loadingFrontpage, setLoadingFrontpage] = useState(true);
  const [clickedButton, setClickedButton] = useState("Today");
  const [hideEstimate, setHideEstimate] = useState(false);
  // const [isReloadLoading, setIsReloadLoading] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  // const [selectedCountries, setSelectedCountries] = useState([]);
  const { Option } = Select;
  const [selectedImpacts, setSelectedImpacts] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);

  const [isVisible, setIsVisible] = useState(false);
  const [checkNext7daysRange, setCheckNext7daysRange] = useState(false);
  const [checkDatesRange, setCheckDatesRange] = useState(false);

  const [mobileStartDate, setMobileStartDate] = useState(null);
  const [mobileEndDate, setMobileEndDate] = useState(null);

  const [isOpen1, setIsOpen1] = useState(false);

  // const timezones = [
  //   // { label: "(GMT) Coordinated Universal Time", tz: "Etc/UTC" },
  //   { label: "(GMT -11:00) Midway Island", tz: "Pacific/Midway" },
  //   { label: "(GMT -11:00) Samoa", tz: "Pacific/Pago_Pago" },
  //   { label: "(GMT -10:00) Hawaii", tz: "Pacific/Honolulu" },
  //   { label: "(GMT -8:00) Alaska", tz: "America/Anchorage" },
  //   { label: "(GMT -7:00) Arizona", tz: "America/Phoenix" },
  //   { label: "(GMT -7:00) Baja California", tz: "America/Tijuana" },
  //   {
  //     label: "(GMT -7:00) Pacific Time (US & Canada)",
  //     tz: "America/Los_Angeles",
  //   },
  //   {
  //     label: "(GMT -6:00) Chihuahua, La Paz, Mazatlan",
  //     tz: "America/Chihuahua",
  //   },
  //   {
  //     label: "(GMT -6:00) Guadalajara, Mexico City, Monterrey",
  //     tz: "America/Mexico_City",
  //   },
  //   { label: "(GMT -6:00) Mountain Time (US & Canada)", tz: "America/Denver" },
  //   { label: "(GMT -5:00) Bogota, Lima, Quito", tz: "America/Bogota" },
  //   { label: "(GMT -5:00) Central America", tz: "America/Guatemala" },
  //   { label: "(GMT -5:00) Central Time (US & Canada)", tz: "America/Chicago" },
  //   { label: "(GMT -5:00) Saskatchewan", tz: "America/Regina" },
  //   { label: "(GMT -4:00) Asuncion", tz: "America/Asuncion" },
  //   { label: "(GMT -4:00) Caracas", tz: "America/Caracas" },
  //   { label: "(GMT -4:00) Cuiaba", tz: "America/Cuiaba" },
  //   { label: "(GMT -4:00) Eastern Time (US & Canada)", tz: "America/New_York" },
  //   {
  //     label: "(GMT -4:00) Georgetown, La Paz, Manaus, San Juan",
  //     tz: "America/La_Paz",
  //   },
  //   { label: "(GMT -4:00) Indiana (East)", tz: "America/Indiana/Indianapolis" },
  //   { label: "(GMT -4:00) Santiago", tz: "America/Santiago" },
  //   { label: "(GMT -3:00) Atlantic Time (Canada)", tz: "Canada/Atlantic" },
  //   { label: "(GMT -3:00) Brasilia", tz: "America/Sao_Paulo" },
  //   { label: "(GMT -3:00) Buenos Aires", tz: "America/Argentina/Buenos_Aires" },
  //   { label: "(GMT -3:00) Cayenne, Fortaleza", tz: "America/Fortaleza" },
  //   { label: "(GMT -3:00) Montevideo", tz: "America/Montevideo" },
  //   { label: "(GMT -2:30) Newfoundland", tz: "America/St_Johns" },
  //   { label: "(GMT -2:00) Greenland", tz: "America/Godthab" },
  //   { label: "(GMT -1:00) Cape Verde Is.", tz: "Atlantic/Cape_Verde" },
  //   { label: "(GMT) Azores", tz: "Atlantic/Azores" },
  //   { label: "(GMT) Coordinated Universal Time", tz: "Etc/UTC" },
  //   { label: "(GMT) Monrovia, Reykjavik", tz: "Atlantic/Reykjavik" },
  //   { label: "(GMT +1:00) Casablanca", tz: "Africa/Casablanca" },
  //   {
  //     label: "(GMT +1:00) Dublin, Edinburgh, Lisbon, London",
  //     tz: "Europe/London",
  //   },
  //   { label: "(GMT +1:00) Lagos", tz: "Africa/Lagos" },
  //   { label: "(GMT +1:00) West Central Africa", tz: "Africa/Algiers" },
  //   {
  //     label: "(GMT +2:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  //     tz: "Europe/Berlin",
  //   },
  //   {
  //     label: "(GMT +2:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  //     tz: "Europe/Belgrade",
  //   },
  //   {
  //     label: "(GMT +2:00) Brussels, Copenhagen, Madrid, Paris",
  //     tz: "Europe/Paris",
  //   },
  //   { label: "(GMT +2:00) Cairo", tz: "Africa/Cairo" },
  //   { label: "(GMT +2:00) Johannesburg", tz: "Africa/Johannesburg" },
  //   {
  //     label: "(GMT +2:00) Sarajevo, Skopje, Warsaw, Zagreb",
  //     tz: "Europe/Warsaw",
  //   },
  //   { label: "(GMT +2:00) Windhoek", tz: "Africa/Windhoek" },
  //   { label: "(GMT +3:00) Amman", tz: "Asia/Amman" },
  //   { label: "(GMT +3:00) Baghdad", tz: "Asia/Baghdad" },
  //   { label: "(GMT +3:00) Beirut", tz: "Asia/Beirut" },
  //   { label: "(GMT +3:00) Damascus", tz: "Asia/Damascus" },
  //   {
  //     label: "(GMT +3:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  //     tz: "Europe/Kiev",
  //   },
  //   { label: "(GMT +3:00) Istanbul", tz: "Europe/Istanbul" },
  //   { label: "(GMT +3:00) Jerusalem", tz: "Asia/Jerusalem" },
  //   { label: "(GMT +3:00) Kuwait, Riyadh", tz: "Asia/Riyadh" },
  //   {
  //     label: "(GMT +3:00) Moscow, St. Petersburg, Volgograd",
  //     tz: "Europe/Moscow",
  //   },
  //   { label: "(GMT +3:00) Nairobi", tz: "Africa/Nairobi" },
  //   { label: "(GMT +3:30) Tehran", tz: "Asia/Tehran" },
  //   { label: "(GMT +4:00) Abu Dhabi, Dubai, Muscat", tz: "Asia/Dubai" },
  //   { label: "(GMT +4:00) Baku", tz: "Asia/Baku" },
  //   { label: "(GMT +4:30) Kabul", tz: "Asia/Kabul" },
  //   { label: "(GMT +5:00) Ekaterinburg", tz: "Asia/Yekaterinburg" },
  //   { label: "(GMT +5:00) Karachi", tz: "Asia/Karachi" },
  //   {
  //     label: "(GMT +5:30) Chennai, Kolkata, Mumbai, New Delhi",
  //     tz: "Asia/Kolkata",
  //   },
  //   { label: "(GMT +5:30) Colombo", tz: "Asia/Colombo" },
  //   { label: "(GMT +5:45) Kathmandu", tz: "Asia/Kathmandu" },
  //   { label: "(GMT +6:00) Dhaka", tz: "Asia/Dhaka" },
  //   { label: "(GMT +6:30) Yangon (Rangoon)", tz: "Asia/Yangon" },
  //   { label: "(GMT +7:00) Bangkok, Hanoi, Jakarta", tz: "Asia/Bangkok" },
  //   {
  //     label: "(GMT +8:00) Beijing, Chongqing, Hong Kong, Urumqi",
  //     tz: "Asia/Shanghai",
  //   },
  //   { label: "(GMT +8:00) Manila", tz: "Asia/Manila" },
  //   { label: "(GMT +8:00) Singapore", tz: "Asia/Singapore" },
  //   { label: "(GMT +9:00) Osaka, Sapporo, Tokyo", tz: "Asia/Tokyo" },
  //   { label: "(GMT +9:00) Seoul", tz: "Asia/Seoul" },
  //   { label: "(GMT +9:30) Adelaide", tz: "Australia/Adelaide" },
  //   { label: "(GMT +10:00) Brisbane", tz: "Australia/Brisbane" },
  //   {
  //     label: "(GMT +10:00) Canberra, Melbourne, Sydney",
  //     tz: "Australia/Sydney",
  //   },
  //   { label: "(GMT +10:00) Vladivostok", tz: "Asia/Vladivostok" },
  //   {
  //     label: "(GMT +11:00) Solomon Is., New Caledonia",
  //     tz: "Pacific/Guadalcanal",
  //   },
  //   { label: "(GMT +12:00) Auckland, Wellington", tz: "Pacific/Auckland" },
  //   { label: "(GMT +12:00) Eniwetok, Kwajalein", tz: "Pacific/Kwajalein" },
  // ];
  // const [selectedZone, setSelectedZone] = useState(timezones[0]);
  // const handleSelect = (zone) => {

  //   setSelectedZone(zone);
  //   setIsOpen1(false);
  //   handleTimezoneChange({ target: { value: zone.tz } });
  // };

  // const handleSelect = (e) => {
  //   const zone = timezones.find((z) => z.tz === e.target.value);
  //   if (zone) {
  //     setSelectedZone(zone);
  //     localStorage.setItem("Timezone Selected", zone.label);
  //   }
  // };



  const convertToSelectedZone = (dateStr, timeStr, selectedZone) => {
    // console.log("Input:", dateStr, timeStr, selectedZone);

    if (!selectedZone?.tz) {
      return { date: dateStr, time: timeStr.slice(0, 5) };
    }

    const rawUtc = DateTime.fromFormat(
      `${dateStr} ${timeStr}`,
      "yyyy.MM.dd HH:mm:ss",
      { zone: "utc" }
    );

    // console.log("Parsed UTC:", rawUtc.toString());

    const local = rawUtc.setZone(selectedZone.tz);

    // console.log("Converted to local zone:", local.toString());

    return {
      date: local.toFormat("yyyy.MM.dd"),
      time: local.toFormat("HH:mm")
    };
  };
  const handleSelect = (labelString) => {
    const zone = timezones.find(z => z.label === labelString);
    if (zone) {
      setSelectedZone(zone);
    }
  };

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  // useEffect(() => {
  //   console.log("searchTerm-->", searchTerm);
  // }, [searchTerm]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedCountry(typeof value === "string" ? value.split(",") : value);
  };

  // const handleImpactChange = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setSelectedImpacts(typeof value === "string" ? value.split(",") : value);
  // };

  const handleImpactChange = (values) => {
    setSelectedImpacts(values);
  };
  const handleCountryChange = (values) => {
    setSelectedCountry(values);
  };

  // const handleSearch = (e) => {
  //   setSearchTerm(e.target.value);
  // };

  const getSerchresult = async () => {
    if (!searchTerm) {
      handleTodayClick();
      setLoading(false);
      setLoadingFrontpage(false);
      return;
    }

    try {
      setLoading(true);
      setLoadingFrontpage(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/searchevents`,
        { searchTerm }
      );


      console.log("response after search", response);

      const final_filteredData = response.data.uniqueEvents.map(item => {
        const { date: localDate, time: localTime } =
          convertToSelectedZone(item.date, item.time, selectedZone);
        return { ...item, localDate, localTime };
      });
      setmaindata(final_filteredData);
      setClickedButton("");
      setclickedon("");
      // console.log("respone this search" ,response.data)
      setLoading(false);
      setLoadingFrontpage(false);
    } catch (error) {
      setLoading(false);
      setLoadingFrontpage(false);
      console.error("Error searching events:", error);
      setErrorMessage(
        error.response?.data?.error || "Error fetching search results."
      );
    }
  };
  // const handleSearch = async (e) => {
  //   const searchValue = e.target.value;
  //   setSearchTerm(searchValue);

  // };

  const handlefilter = () => {
    // console.log("hlo i ma here");
    setSearchTerm("");
    setDateRange(null);
    setSelectedImpacts([]);
    setSelectedCountry([]);
    handleTodayClick();
    setMobileEndDate([]);
    setMobileStartDate([]);
  };

  // <<-------for today , yesterday , tomorrow , and next week data on screen -------->>

  const handleTodayClick = async () => {
    // console.log("hi today api git hit")
    setLoading(true);
    setLoadingFrontpage(true);

    const tokenfromls = localStorage.getItem("usertoken");

    const h = { authorization: tokenfromls };
    const endpoint = `${process.env.REACT_APP_URL}/todaydata`;
    try {
      console.log("hi next 7 try")

      const response = await axios.get(endpoint, { headers: h });
      let filteredData = response.data;
      console.log("Me hu filtered data durgesh  ", filteredData);

      const final_filteredData = response.data.uniqueEvents.map(item => {
        const { date: localDate, time: localTime } =
          convertToSelectedZone(item.date, item.time, selectedZone);
        return { ...item, localDate, localTime };
      });



      // console.log("filteredData today" , filteredData)
      setClickedButton("Today");
      //  return;
      setmaindata(final_filteredData);
      setLoading(false);
      setLoadingFrontpage(false);
      setIsVisible(false);
      setDateRange(null);
      setclickedon("today");
      setCheckNext7daysRange(false);
      setSearchTerm("");
      // setIsVisible(false);
      // setclickedend("todaydata");
    } catch (error) {
      setLoading(false);
      setLoadingFrontpage(false);
      setClickedButton("Today");

      setclickedon("today");
      setSearchTerm("");
      // setclickedend("todaydata");

      if (error.response && error.response.status === 400) {
        setErrorMessage(errorMessage);
        setmaindata([]);
        setLoadingFrontpage(false);
      } else {
        const errorMessage = "Error fetching data. Please try again later.";
        setErrorMessage(errorMessage);
      }
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
    handleTodayClick();
  }, [selectedZone])
  const handleYesterdayClick = async () => {
    setLoading(true);
    setLoadingFrontpage(true);
    const tokenfromls = localStorage.getItem("usertoken");

    const h = { authorization: tokenfromls };
    const endpoint = `${process.env.REACT_APP_URL}/yesterdaydata`;
    try {
      const response1 = await axios.get(endpoint, { headers: h });

      let filteredData = response1.data;
      const final_filteredData = response1.data.uniqueEvents.map(item => {
        const { date: localDate, time: localTime } =
          convertToSelectedZone(item.date, item.time, selectedZone);
        return { ...item, localDate, localTime };
      });

      setClickedButton("Yesterday");
      setmaindata(final_filteredData);
      setLoading(false);
      setLoadingFrontpage(false);
      setIsVisible(false);
      setDateRange(null);
      setclickedon("yesterday");
      setCheckNext7daysRange(false);
      // setclickedend("yesterdaydata");
      setSearchTerm("");
    } catch (error) {
      setLoading(false);
      setLoadingFrontpage(false);
      setClickedButton("Yesterday");

      setclickedon("yesterday");
      setSearchTerm("");
      // setclickedend("yesterdaydata");

      if (error.response && error.response.status === 400) {
        setErrorMessage(errorMessage);
        setmaindata([]);
      } else {
        const errorMessage = "Error fetching data. Please try again later.";
        setErrorMessage(errorMessage);
      }
      console.error("Error fetching data:", error);
    }
  };

  const handleTomorrowClick = async () => {
    // console.log("hi am tomo clicked api")
    setLoading(true);
    setLoadingFrontpage(true);

    setErrorMessage("");

    const tokenfromls = localStorage.getItem("usertoken");

    const h = { authorization: tokenfromls };
    const endpoint = `${process.env.REACT_APP_URL}/tomorrowdata`;
    try {
      // console.log("hi am in try tomorrow")

      const response2 = await axios.get(endpoint, { headers: h });

      const filteredData = response2.data;
      const final_filteredData = response2.data.uniqueEvents.map(item => {
        const { date: localDate, time: localTime } =
          convertToSelectedZone(item.date, item.time, selectedZone);
        return { ...item, localDate, localTime };
      });

      // console.log("tom result---------------", filteredData)
      // return;
      setClickedButton("Tomorrow");
      setmaindata(final_filteredData);
      setLoading(false);
      setLoadingFrontpage(false);
      setIsVisible(false);
      setclickedon("tomorrow");
      setCheckNext7daysRange(false);
      // setclickedend("tomorrowdata");
      setDateRange(null);
      setSearchTerm("");
    } catch (error) {
      setLoading(false);
      setLoadingFrontpage(false);
      setClickedButton("Tomorrow");
      setclickedon("tomorrow");
      // setclickedend("tomorrowdata");
      setSearchTerm("");
      if (error.response && error.response.status === 400) {
        setErrorMessage(errorMessage);
        setmaindata([]);
      } else {
        const errorMessage = "Error fetching data. Please try again later.";
        setErrorMessage(errorMessage);
      }

      console.error("Error fetching data:", error);
    }
  };
  const handleweekClick = async () => {
    setLoading(true);
    setLoadingFrontpage(true);
    const tokenfromls = localStorage.getItem("usertoken");

    const h = { authorization: tokenfromls };
    // setclickedend("nextdaysdata");
    const endpoint = `${process.env.REACT_APP_URL}/nextdaysdata`;
    try {
      const response3 = await axios.get(endpoint, { headers: h });
      console.log("response3", response3)
      // const flattenedData = Array.isArray(response3.data)
      //   ? response3.data.uniqueEvents.flatMap((innerArray) => innerArray)
      //   : [];
      const flattenedData = response3.data.uniqueEvents;
      console.log("me hu flttend data", flattenedData);

      const final_filteredData = response3.data.uniqueEvents.map(item => {
        const { date: localDate, time: localTime } =
          convertToSelectedZone(item.date, item.time, selectedZone);
        return { ...item, localDate, localTime };
      });

      // console.log("flattenedData" , flattenedData)
      setClickedButton("Next7Days");
      // setmaindata(flattenedData);
      setmaindata(final_filteredData);

      setclickedon("nextdays");
      // setclickedend("nextdaysdata");
      setLoading(false);
      setLoadingFrontpage(false);
      setIsVisible(false);
      setDateRange(null);
      setCheckNext7daysRange(true);
      setSearchTerm("");
    } catch (error) {
      setLoading(false);
      setLoadingFrontpage(false);
      setClickedButton("Next7Days");
      setclickedon("nextdays");
      // setclickedend("nextdaysdata");
      setSearchTerm("");
      if (error.response && error.response.status === 400) {
        setErrorMessage(errorMessage);
        setmaindata([]);
      } else {
        const errorMessage = "Error fetching data. Please try again later.";
        setErrorMessage(errorMessage);
      }
      console.error("Error fetching data:", error);
    }
  };
  // Enter button search function
  const handlePressEnter = (e) => {
    if (e.key === "Enter") {
      getSerchresult();
      // console.log("Updated searchTerm:", e.target.value);
    }
  };
  // const handlelast4monthsClick = async() => {
  //   setLoading(true);
  //   // console.log("hlo am clicked");

  //   const tokenfromls = localStorage.getItem("usertoken");
  //   const h = { authorization: tokenfromls };

  //   const endpoint = `${process.env.REACT_APP_URL}/last4monthsdata`;
  // try{
  // const response = await axios.get(endpoint, { headers: h })

  // let filteredData = response.data;
  // // setClickedButton("Tomorrow");
  // // setmaindata(filteredData.uniqueEvents);
  // // setLoading(false);

  // // setclickedon("tomorrow");
  // // console.log("filteredData" , filteredData)
  // setmaindata(filteredData.uniqueEvents);
  // setLoading(false);
  // // setfinalfiltereddata(filteredData)
  // setClickedButton("Last4months");
  // setclickedon("last4months");

  // setDateRange(null);
  // // setmaindata(filteredData);
  // }
  // catch(error) {
  //       setClickedButton("Last4months");
  //       setclickedon("last4months");

  //       setLoading(false);
  //       if (error.response && error.response.status === 400) {
  //         setErrorMessage(errorMessage);
  //         setmaindata([]);
  //       } else {
  //         const errorMessage = "Error fetching data. Please try again later.";
  //         setErrorMessage(errorMessage);
  //       }
  //       console.error("Error fetching data:", error);
  //     };
  // };

  const handleRefresh = () => {
    // setIsReloadLoading(true);
    setLoading(false);
    setLoadingFrontpage(false);
    // Loop through localStorage and remove any item with "Clickeddate_data_"
    Object.keys(localStorage).forEach((key) => {
      if (
        key.includes("Clickeddate_data_") ||
        key.includes("table3_historyData_") ||
        key.includes("clickedmodal_data_2ndpage_")
      ) {
        localStorage.removeItem(key);
      }
    });

    localStorage.removeItem("All_events_history");
    localStorage.removeItem("lastDeletionTime");
    localStorage.removeItem("UserId");
    localStorage.removeItem("userId");
    localStorage.removeItem("selectedtime");
    localStorage.removeItem("4GraphDataobjects");
    // localStorage.removeItem("userregisterId");
    // localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("todayDate");
    localStorage.removeItem("previousDate_u_search_history");
    localStorage.removeItem("eventnameandcountry:");

    localStorage.removeItem("selectedtime");
    localStorage.removeItem("userEmail");
    // localStorage.removeItem("previousDate_u_search_history");
    // localStorage.removeItem("previousDate_u_search_history");

    // window.location.reload();
  };

  const [modalShow, setModalshow] = useState(false);

  const handleModalShowClick = () => {
    setModalshow(true);
  };
  useEffect(() => {
    handleTodayClick();
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setModalshow(false);
      }
    };

    if (modalShow) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [modalShow]);

  // <----------impact and country filters---------->

  // const handleCountryChange = (values) => {
  //   // console.log("hlo am in country filter")
  //   // setLoading(true);
  //   setSelectedCountry(values);
  //   // console.log("values.length" )
  // };

  const handleDateChange = async (dates, dateStrings) => {
    setLoading(true);
    setLoadingFrontpage(true);
    setDateRange(dates);
    // const tokenfromls = localStorage.getItem("token");
    // const h = { authorization: tokenfromls };
    const [startDate, endDate] = dateStrings;
    if (!dates) {
      setDateRange(null);
      // setmaindata();
      // setClickedButton("Today");
      handleTodayClick();
      setLoading(false);
      setLoadingFrontpage(false);
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/datepicker`,
        { startDate, endDate }
        // { headers: h }
      );
      // setDateRange(dates);
      // console.log("Dates---->" , startDate , "" , + "" , endDate)

      const final_filteredData = response.data.map(item => {
        const { date: localDate, time: localTime } =
          convertToSelectedZone(item.date, item.time, selectedZone);
        return { ...item, localDate, localTime };
      });

      setmaindata(final_filteredData);
      setClickedButton("");
      setclickedon("");
      //  setclickedend("");
      setLoading(false);
      setLoadingFrontpage(false);
      setCheckDatesRange(true);
      // console.log("response.data" , response.data)
    } catch (error) {
      setClickedButton("");
      setclickedon("");
      //  setclickedend("");
      setLoading(false);
      setLoadingFrontpage(false);
      const errorMessage =
        error.response && error.response.status === 400
          ? error.response.data.error
          : "Error fetching data. Please try again later.";
      setErrorMessage(errorMessage);
      console.error("Error fetching data:", error);
    }
    setDateRange(dates);
  };

  // <--------------toggle estimate fields on frontend------------>
  // const handleEstimateToggle = () => {
  //   setHideEstimate(!hideEstimate);
  // };

  const handlesaved_tradeoptions = () => {
    // navigate("/user/savedtradeOptions")
    window.open("/user/savedtradeOptions", "_blank");
  };

  const handletradepage = () => {
    window.open("/user/buysell", "_blank");
  };

  const handleCommodityPage = () => {
    navigate("/user/economicdataCommodity");
  };
  const handleResize = () => {
    const widthThreshold = 1500; // Set your desired width
    if (window.innerWidth <= widthThreshold) {
      setIsOpen(false);
    } else {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    // Run once on mount
    handleResize();

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOverlayClick = (e) => {
    // Close modal only if clicking outside the modal content
    if (e.target.id === "overlay") {
      setIsVisible(false);
      setIsOpen1(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  //  const compare_btn = ()=>{
  //    const url = new URL(window.location.origin + "/user/eventshistory_comparison");
  //       // url.searchParams.set("eventName", event);
  //       // url.searchParams.set("eventcountry", country);

  //       const newTab = window.open(url.toString(), "_blank");

  //  }

  //  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedIdString, setSelectedIdString] = useState("");
  const [final_selectedCountry, setFinal_selectedCountry] = useState("");
  const [final_selectedDate, setFinal_selectedDate] = useState("");
  const [final_selectedTime, setFinal_selectedTime] = useState("");
  //  const navigate = useNavigate();

  const handleSelectedIdString = (ids) => {
    setSelectedIdString(ids); // Already a string with commas
  };

  const handleCountry = (finalCountry) => {
    setFinal_selectedCountry(finalCountry);
  };
  const handleDate = (finalDate) => {
    setFinal_selectedDate(finalDate);
  };
  const handleTime = (finalTime) => {
    setFinal_selectedTime(finalTime);
  };

  //  const compare_btn = () => {
  //   console.log("selectedIds" , selectedIds)
  //    if (selectedIds.length === 0) {
  //      alert('Please select data first.');
  //      return;
  //    }
  //    navigate('/user/eventshistory_comparison', { state: { selectedIds } });
  //  };

  const [showCompareCheckboxes, setShowCompareCheckboxes] = useState(false);

  const compare_btn = () => {
    if (!showCompareCheckboxes) {
      setShowCompareCheckboxes(true);
      return;
    }
    if (!selectedIdString) {
      toast.error("Please select at least one item.", {
        position: "top-right",
      });
      return;
    }
    if (!final_selectedCountry) {
      toast.error("Please select one country.", { position: "top-right" });
    }
    // console.log("final_selectedCountry", final_selectedCountry);
    // Open in a new tab with query parameters
    const url = `/user/eventshistory_comparison?eventIDs=${encodeURIComponent(
      selectedIdString
    )}&country=${encodeURIComponent(
      final_selectedCountry
    )}&date=${encodeURIComponent(final_selectedDate)}&time=${encodeURIComponent(
      final_selectedTime
    )}`;
    window.open(url, "_blank");
    // setSelectedIdString("")
  };
  const [resetCheckboxes, setResetCheckboxes] = useState(false);

  const empty_checkbox_selected = () => {
    handleSelectedIdString("");
    setSelectedIdString("");
    setResetCheckboxes(true);
  };

  const handleTimezoneChange = (e) => {
    // console.log("Selected timezone:", e.target.value);
    // moment.tz.setDefault(e.target.value); ← if using moment-timezone
  };

  // return (
  //   <div>
  //     <div>
  //       <div>
  //         <UserNavbar />
  //       </div>

  //       <div className="flex flex-row ">
  //         {/* <---sidebar---> */}
  //         <div
  //           className={`${
  //             styles.sidebar_class
  //           } fixed h-[100vh] hidden lg:block pt-[6%] transition-all duration-400  ease-in-out cursor-pointer  ${
  //             isOpen ? "min-w-[13%]" : "min-w-[5%]"
  //           } bg-[#D2C2F0]  p-4`}
  //         >
  //           <div
  //             className={`  ${styles.savedhistorybtn} mb-4 top-[12%] fixed top:0 flex flex-col items-center justify-center w-[82px]`}
  //             onClick={handlesaved_tradeoptions}
  //           >
  //             <img
  //               src={savedicon}
  //               alt="Saved Icon"
  //               className={` ${isOpen ? "h-6 w-4 ml-2" : "h-6 w-5 ml-1"}`}
  //               title="Check history of saved trade"
  //             />

  //             {/* {isOpen && ( */}
  //             <h1 className="text-[14px] font-bold  mt-2 break-words text-[#240d3a]">
  //               Trade Log
  //             </h1>
  //             {/* )} */}
  //           </div>
  //           {/* <div
  //             className="cursor-pointer absolute top-[9.5rem] right-[-18px]"
  //             onClick={() => setIsOpen(!isOpen)}
  //           >
  //             {isOpen ? (
  //               <img
  //                 src={hamburger}
  //                 alt="image"
  //                 className="h-[40px] w-[40px]"
  //               />
  //             ) : (
  //               <img
  //                 src={hamburger1}
  //                 alt="image"
  //                 className="h-[40px] w-[40px]"
  //               />
  //             )}


  //           </div> */}
  //           {/* Sidebar Content */}
  //           <div className="mt-[21vh] ">
  //             <div
  //               className={`flex flex-col  ${
  //                 isOpen ? "items-start" : "items-center"
  //               }`}
  //             >
  //               {/* <---hlo---> */}

  //               <div
  //                 className={`relative px-0 mb-4 flex justify-start items-start flex-col`}
  //               >
  //                 <div className="flex justify-center items-center flex-col">
  //                   <div className="relative flex items-center justify-center text-center">
  //                     <div>
  //                       <span
  //                         className="ml-0 mt-[16%] flex align-center justify-center text-center"
  //                         onClick={handleYesterdayClick}
  //                       >
  //                         {clickedButton === "Yesterday" ? (
  //                           <img
  //                             src={yesterday_img_icon_active}
  //                             alt="today_img"
  //                             className="h-[45px] w-[44px]"
  //                           />
  //                         ) : (
  //                           <img
  //                             src={yesterday_img_icon}
  //                             alt="today_img"
  //                             className="h-[45px] w-[44px]"
  //                           />
  //                         )}
  //                       </span>
  //                       <button
  //                         type="button"
  //                         onClick={handleYesterdayClick}
  //                         className={`h-[40px] text-[14px] font-bold  inline-flex items-center justify-center w-full  pb-2   rounded-md transition-opacity duration-300  ${
  //                           clickedButton === "Yesterday"
  //                             ? " text-[#630bb8]"
  //                             : " text-[#240d3a]"
  //                         }`}
  //                       >
  //                         Yesterday
  //                       </button>
  //                     </div>

  //                     {clickedButton === "Yesterday" && (
  //                       <div className=" absolute top-[37%] right-[-70%] transform -translate-y-1/2 w-0 h-0 border-t-[20.5px] border-b-[20.5px] border-l-[34px] border-transparent border-l-[#D2C2F0]"></div>
  //                     )}
  //                   </div>
  //                   <div className="relative flex items-center justify-center text-center">
  //                     <div>
  //                       <span
  //                         className="ml-0 mt-[16%] flex align-center justify-center text-center"
  //                         onClick={handleTodayClick}
  //                       >
  //                         {clickedButton === "Today" ? (
  //                           <img
  //                             src={today_img_icon_active}
  //                             alt="today_img"
  //                             className="h-[40px] w-[44px]"
  //                           />
  //                         ) : (
  //                           <img
  //                             src={today_img_icon}
  //                             alt="today_img"
  //                             className="h-[40px] w-[44px]"
  //                           />
  //                         )}
  //                       </span>
  //                       <button
  //                         type="button"
  //                         onClick={handleTodayClick}
  //                         className={`h-[40px] text-[14px]  font-bold inline-flex items-center justify-center w-full  pb-2    rounded-md transition-opacity duration-300  
  //                       ${
  //                         clickedButton === "Today"
  //                           ? " text-[#630bb8]"
  //                           : " text-[#240d3a]"
  //                       }`}
  //                       >
  //                         Today
  //                       </button>
  //                       {clickedButton === "Today" && (
  //                         <div className=" absolute top-[35%] right-[-142%] transform -translate-y-1/2 w-0 h-0 border-t-[20.5px] border-b-[20.5px] border-l-[34px] border-transparent border-l-[#D2C2F0]"></div>
  //                       )}
  //                     </div>
  //                   </div>
  //                   <div className="relative flex items-center justify-center text-center">
  //                     <div>
  //                       <span
  //                         className="ml-0 mt-[16%] flex align-center justify-center text-center"
  //                         onClick={handleTomorrowClick}
  //                       >
  //                         {clickedButton === "Tomorrow" ? (
  //                           <img
  //                             src={tomorrow_img_icon_active}
  //                             alt="today_img"
  //                             className="h-[45px] w-[44px]"
  //                           />
  //                         ) : (
  //                           <img
  //                             src={tomorrow_img_icon}
  //                             alt="today_img"
  //                             className="h-[45px] w-[44px]"
  //                           />
  //                         )}
  //                       </span>
  //                       <button
  //                         type="button"
  //                         onClick={handleTomorrowClick}
  //                         className={`h-[40px]  text-[14px] inline-flex items-center justify-center w-full  pb-2  font-bold  rounded-md transition-opacity duration-300  ${
  //                           clickedButton === "Tomorrow"
  //                             ? " text-[#630bb8]"
  //                             : " text-[#240d3a]"
  //                         }`}
  //                       >
  //                         Tomorrow
  //                       </button>
  //                       {clickedButton === "Tomorrow" && (
  //                         <div className=" absolute top-[37%] right-[-68%] transform -translate-y-1/2 w-0 h-0 border-t-[20.5px] border-b-[20.5px] border-l-[34px] border-transparent border-l-[#D2C2F0]"></div>
  //                       )}
  //                     </div>
  //                   </div>

  //                   <div className="relative flex items-center justify-center text-center">
  //                     <div>
  //                       <span
  //                         className="ml-0 mt-[16%] flex align-center justify-center text-center"
  //                         onClick={handleweekClick}
  //                       >
  //                         {clickedButton === "Next7Days" ? (
  //                           <img
  //                             src={next7days_img_icon_active}
  //                             alt="today_img"
  //                             className="h-[45px] w-[44px]"
  //                           />
  //                         ) : (
  //                           <img
  //                             src={next7days_img_icon}
  //                             alt="today_img"
  //                             className="h-[45px] w-[44px]"
  //                           />
  //                         )}
  //                       </span>
  //                       <button
  //                         type="button"
  //                         onClick={handleweekClick}
  //                         className={`h-[40px]  inline-flex text-[14px] items-center justify-center w-full  pb-2  font-bold  rounded-md transition-opacity duration-300  ${
  //                           clickedButton === "Next7Days"
  //                             ? " text-[#630bb8] "
  //                             : " text-[#240d3a] "
  //                         }`}
  //                       >
  //                         Next 7 Days
  //                       </button>
  //                     </div>
  //                     {clickedButton === "Next7Days" && (
  //                       <div className=" absolute top-[39%] right-[-52%] transform -translate-y-1/2 w-0 h-0 border-t-[20.5px] border-b-[20.5px] border-l-[34px] border-transparent border-l-[#D2C2F0]"></div>
  //                     )}
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           {/* <------mobile view sidebar start ------> */}
  //         </div>

  //         {isVisible && (
  //           <div
  //             id="overlay"
  //             className="fixed inset-0 z-[998] bg-black bg-opacity-50 flex items-end"
  //             onClick={handleOverlayClick}
  //           >
  //             <div
  //               className={`p-2 z-[999] bg-white rounded-t-[20px] w-full h-[34%] flex flex-col justify-center relative transition-all duration-500 transform ease-out ${
  //                 isVisible ? "translate-y-0" : "translate-y-full"
  //               }`}
  //             >
  //               {/* Cross Button */}
  //               <button
  //                 className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
  //                 onClick={() => setIsVisible(false)}
  //                 aria-label="Close Modal"
  //               >
  //                 <svg
  //                   xmlns="http://www.w3.org/2000/svg"
  //                   fill="none"
  //                   viewBox="0 0 24 24"
  //                   strokeWidth="2"
  //                   stroke="currentColor"
  //                   className="w-6 h-6"
  //                 >
  //                   <path
  //                     strokeLinecap="round"
  //                     strokeLinejoin="round"
  //                     d="M6 18L18 6M6 6l12 12"
  //                   />
  //                 </svg>
  //               </button>

  //               <div className="flex  items-center justify-around w-full">
  //                 <div className="flex  items-center border-2 rounded-[14px] border-[#fff] py-3 px-2 w-[180px]  md:w-[230px] ">
  //                   {" "}
  //                   <span className="ml-2">
  //                     {clickedButton === "Yesterday" ? (
  //                       <img
  //                         src={yesterday_img_icon_active_m}
  //                         alt="today_img"
  //                         className="h-[40px] w-[65px]"
  //                       />
  //                     ) : (
  //                       <img
  //                         src={yesterday_img_icon_m}
  //                         alt="today_img"
  //                         className="h-[40px] w-[65px]"
  //                       />
  //                     )}
  //                   </span>
  //                   <button
  //                     type="button"
  //                     onClick={handleYesterdayClick}
  //                     className={`h-[40px] text-[16px] ml-2 inline-flex items-center justify-center w-full  py-2  font-medium  rounded-md transition-opacity duration-300  ${
  //                       clickedButton === "Yesterday"
  //                         ? " text-[#630bb8]"
  //                         : " text-[#240d3a]"
  //                     }`}
  //                   >
  //                     Yesterday
  //                   </button>
  //                 </div>
  //                 <div className="flex  items-center border-2 rounded-[14px] border-[#fff] py-3 px-2 w-[180px]  md:w-[230px] ">
  //                   <span className="ml-2">
  //                     {clickedButton === "Today" ? (
  //                       <img
  //                         src={today_img_icon_active_m}
  //                         alt="today_img"
  //                         className="h-[37px] w-[71px]"
  //                       />
  //                     ) : (
  //                       <img
  //                         src={today_img_icon_m}
  //                         alt="today_img"
  //                         className="h-[37px] w-[71px]"
  //                       />
  //                     )}
  //                   </span>

  //                   <button
  //                     type="button"
  //                     onClick={handleTodayClick}
  //                     className={`h-[40px] text-[16px] ml-5 font-bold inline-flex items-center w-full  py-2   rounded-md transition-opacity duration-300  
  //                       ${
  //                         clickedButton === "Today"
  //                           ? " text-[#630bb8]"
  //                           : " text-[#240d3a]"
  //                       }`}
  //                   >
  //                     Today
  //                   </button>
  //                 </div>
  //               </div>
  //               <div className="mt-6 flex  items-center justify-around w-full">
  //                 <div className="flex  items-center border-2 rounded-[14px] border-[#fff] py-3 px-2 w-[180px]  md:w-[230px] ">
  //                   <span className="ml-2">
  //                     {clickedButton === "Tomorrow" ? (
  //                       <img
  //                         src={tomorrow_img_icon_active_m}
  //                         alt="today_img"
  //                         className="h-[40px] w-[65px]"
  //                       />
  //                     ) : (
  //                       <img
  //                         src={tomorrow_img_icon_m}
  //                         alt="today_img"
  //                         className="h-[40px] w-[65px]"
  //                       />
  //                     )}
  //                   </span>
  //                   <button
  //                     type="button"
  //                     onClick={handleTomorrowClick}
  //                     className={`h-[40px] ml-2 text-[16px] inline-flex items-center justify-center w-full  py-2  font-medium  rounded-md transition-opacity duration-300  ${
  //                       clickedButton === "Tomorrow"
  //                         ? " text-[#630bb8]"
  //                         : " text-[#240d3a]"
  //                     }`}
  //                   >
  //                     Tomorrow
  //                   </button>
  //                 </div>
  //                 <div className="flex  items-center border-2 rounded-[14px] border-[#fff] py-3 px-2 w-[180px]  md:w-[230px] ">
  //                   <span className="ml-2">
  //                     {clickedButton === "Next7Days" ? (
  //                       <img
  //                         src={next7days_img_icon_active_m}
  //                         alt="today_img"
  //                         className="h-[40px] w-[65px]"
  //                       />
  //                     ) : (
  //                       <img
  //                         src={next7days_img_icon_m}
  //                         alt="today_img"
  //                         className="h-[40px] w-[65px]"
  //                       />
  //                     )}
  //                   </span>
  //                   <button
  //                     type="button"
  //                     onClick={handleweekClick}
  //                     className={`h-[40px] ml-2 inline-flex text-[16px] items-center justify-center w-full  py-2  font-medium  rounded-md transition-opacity duration-300  ${
  //                       clickedButton === "Next7Days"
  //                         ? " text-[#630bb8] "
  //                         : " text-[#240d3a] "
  //                     }`}
  //                   >
  //                     Next 7 Days
  //                   </button>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         )}

  //         {/* <------mobile view sidebar end ------> */}

  //         {/* <----main componnet render----> */}
  //         {/* <div
  //           className={` transition-all duration-200  ease-in-out 
  //              "ml-[9%] w-[93%]"
  //          `} */}
  //         <div
  //           className={` transition-all duration-200  ease-in-out 
  //           ml-[6%] sm:ml-[6%] md:ml-[9%] w-[93%]
  //         `}
  //         >
  //           <div className="">
  //             <div
  //               className={`fixed top-[5%] sm:top-[8%] md:top-[10%] ${
  //                 isOpen ? "w-[80%]" : "w-[89%]"
  //               }`}
  //             >
  //               <div className=" z-[999] w-[100%]   ">
  //                 <div
  //                   className={`  ${styles.economiccalender} ml:0 sm:ml-0 md:ml-0  lg:ml-[6%] xl:ml-0 mt-[8%] sm:mt-[9%] md:mt-0 lg:mt-0 xl:mt-0 buttons flex flex-col  items-start  justify-start`}
  //                 >
  //                   <div className="flex justify-between w-full">
  //                     <h1
  //                       className={`  ${styles.economiccalender_h1}   font-bold text-[22px] sm:text-[22px] md:text-[32px] lg:text-[32px] xl:text-[32px]  text-[#240D3A] mt-4`}
  //                     >
  //                       Economic Calendar
  //                     </h1>

  //                     <div className="flex">
  //                       <button
  //                         className="hidden max-[1023px]:block mt-2"
  //                         onClick={handlesaved_tradeoptions}
  //                       >
  //                         <img
  //                           src={savedicon}
  //                           alt="filter icon"
  //                           className={`h-5 w-4 cursor-pointer   `}
  //                         />
  //                       </button>
  //                       <button
  //                         className="ml-2 hidden max-[1023px]:block mt-2"
  //                         onClick={toggleVisibility}
  //                       >
  //                         <img
  //                           src={filter_icon}
  //                           alt="filter icon"
  //                           className={`h-[24px] w-[24px] cursor-pointer   `}
  //                         />
  //                       </button>
  //                     </div>
  //                   </div>
  //                   <div
  //                     className={` ${styles.saved_haeder6} w-full first-div flex flex-col sm:flex-col md:flex-col lg:flex-col xl:flex-row mt-[1%] justify-between`}
  //                   >
  //                     <div className=" flex flex-col sm:flex-col md:flex-col lg:flex-row xl:flex-row">
  //                       <div className="relative block sm:block md:inline-block lg:inline-block xl:inline-block pr-3 sm:pr-0 mb-4 sm:mb-4 md:mb-4 lg:mb-0 xl:mb-0 z-[999] bg-[#F6F6F6]">
  //                         <Space
  //                           style={{ width: "100%" }}
  //                           direction="vertical"
  //                           className="z-[999] border-[#240d3a] "
  //                         >
  //                           <Select
  //                             mode="multiple"
  //                             allowClear
  //                             style={{
  //                               width: "218px",
  //                               height: "46px",
  //                               maxHeight: "46px",
  //                               backgroundColor: "#F6F6F6", // Grey background
  //                               border: "1px solid #240d3a", // Light grey border
  //                               borderRadius: "4px",
  //                             }}
  //                             placeholder={
  //                               <span
  //                                 style={{ color: "#240d3a", fontSize: "16px" }}
  //                               >
  //                                 Country
  //                               </span>
  //                             }
  //                             onChange={handleCountryChange}
  //                             value={selectedCountry}
  //                             getPopupContainer={(triggerNode) => document.body}
  //                             className="z-[999] custom-select overflow-visible"
  //                             dropdownStyle={{
  //                               maxHeight: "800px",
  //                               overflowY: "auto", // Adds vertical scrollbar for dropdown options
  //                             }}
  //                             suffixIcon={
  //                               <DownOutlined
  //                                 style={{
  //                                   fontSize: "14px",
  //                                   color: "#240d3a", // Change icon color here
  //                                 }}
  //                               />
  //                             }
  //                             maxTagCount={1} // Only show one country in the select box
  //                             maxTagTextLength={20} // Adjust max length if necessary
  //                           >
  //                             {/* <Option value="UK">United Kingdom (UK)</Option>
  //       <Option value="US">United States (US)</Option>
  //       <Option value="CA">Canada (CA)</Option>
  //       <Option value="CH">Switzerland (CH)</Option>
  //       <Option value="EU">Europe (EU)</Option>
  //       <Option value="JP">Japan (JP)</Option>
  //       <Option value="AU">Australia (AU)</Option>
  //       <Option value="NZ">New Zealand (NZ)</Option>
  //       <Option value="DE">Germany (DE)</Option>
  //       <Option value="IT">Italy (IT)</Option>
  //       <Option value="FR">France (FR)</Option> */}
  //                             <Option value="AU">Australia (AU)</Option>
  //                             <Option value="CA">Canada (CA)</Option>
  //                             <Option value="EU">Europe (EU)</Option>
  //                             <Option value="FR">France (FR)</Option>
  //                             <Option value="DE">Germany (DE)</Option>
  //                             <Option value="IT">Italy (IT)</Option>
  //                             <Option value="JP">Japan (JP)</Option>
  //                             <Option value="NZ">New Zealand (NZ)</Option>
  //                             <Option value="CH">Switzerland (CH)</Option>
  //                             <Option value="UK">United Kingdom (UK)</Option>
  //                             <Option value="US">United States (US)</Option>
  //                           </Select>
  //                         </Space>
  //                       </div>
  //                       <div className="relative inline-block px-0 sm:px-0 md:px-0 lg:px-3 xl:px-3">
  //                         <Space
  //                           style={{ width: "100%" }}
  //                           direction="vertical"
  //                           className="z-[999] border-[#240d3a] "
  //                         >
  //                           <Select
  //                             mode="multiple"
  //                             allowClear
  //                             style={{
  //                               width: "218px",
  //                               height: "46px",
  //                               maxHeight: "46px",
  //                               backgroundColor: "#F6F6F6", // Grey background
  //                               border: "1px solid #240d3a", // Light grey border
  //                               borderRadius: "4px",
  //                             }}
  //                             placeholder={
  //                               <span
  //                                 style={{ color: "#240d3a", fontSize: "16px" }}
  //                               >
  //                                 Volatility Impact
  //                               </span>
  //                             }
  //                             onChange={handleImpactChange}
  //                             value={selectedImpacts}
  //                             // getPopupContainer={(trigger) => trigger.parentNode}
  //                             getPopupContainer={(triggerNode) => document.body}
  //                             className="z-[999] custom-select overflow-visible"
  //                             dropdownStyle={{
  //                               maxHeight: "800px",
  //                               overflowY: "auto", // Adds vertical scrollbar for dropdown options
  //                             }}
  //                             suffixIcon={
  //                               <DownOutlined
  //                                 style={{
  //                                   fontSize: "14px",
  //                                   color: "#240d3a", // Change icon color here
  //                                 }}
  //                               />
  //                             }
  //                             maxTagCount={1} // Only show one country in the select box
  //                             maxTagTextLength={20} // Adjust max length if necessary
  //                           >
  //                             <Option value="High">High</Option>
  //                             <Option value="Medium">Medium</Option>
  //                             <Option value="Low">Low</Option>
  //                           </Select>
  //                         </Space>
  //                       </div>

  //                       <div
  //                         className={` ${styles.search_economiccalender} w-[280px] h-[46px] relative flex items-center`}
  //                       >
  //                         <input
  //                           type="text"
  //                           placeholder="Search Events"
  //                           className="rounded-l-[4px] placeholder-[#170E32] pl-4 bg-[#F6F6F6] h-[48px] w-[63%] sm:w-[50%] md:w-[218px] lg:w-[218px] xl:w-[218px] p-1 border-[#170E32] border focus:outline-none"
  //                           value={searchTerm}
  //                           onChange={(e) => setSearchTerm(e.target.value)}
  //                           onKeyDown={handlePressEnter}
  //                         />
  //                         <button
  //                           className="bg-[#240d3a] text-white p-3 rounded-r-[4px] h-[48px] flex items-center justify-center border border-[#170E32]"
  //                           onClick={getSerchresult}
  //                         >
  //                           <FaSearch />
  //                         </button>
  //                       </div>

  //                       <div
  //                         className={` ${styles.rangepicker} hidden xl:flex justify-center range-picker items-center  text-center  mt-2 sm:mt-2 md:mt-4 lg:mt-[-4px] xl:mt-[-4px] ml-[-24px] sm:ml-[-24px] md:ml-[-2%] lg:ml-0 xl:ml-0 pl-6 md:pl-6 w-[30vw] sm:w-[30vw] md:w-full `}
  //                         style={{ height: "56px" }}
  //                       >
  //                         <Space direction="vertical" size={16}>
  //                           {/* <RangePicker onChange={handleDateChange}/> */}
  //                           <RangePicker
  //                             value={dateRange}
  //                             onChange={(dates, dateStrings) =>
  //                               handleDateChange(dates, dateStrings)
  //                             }
  //                             dropdownClassName={` ${styles.custom_dropdown}`}
  //                             className="text-[16px] h-[48px] w-[218px] lg:w-[218px] border-[#240d3a] border active:outline-none bg-[#F6F6F6] focus:outline-none  rounded-md placeholder-[#240d3a] custom-rangepicker focus:border-[#240d3a] focus:shadow-none    focus-within:border-[#240d3a] focus-within:shadow-none hover:border-[#240d3a] !important"
  //                           />
  //                         </Space>
  //                         <div>
  //                           <img
  //                             src={filtericondate}
  //                             alt="filter"
  //                             title="Clear All Filters"
  //                             className={`h-[40px] w-[40px] cursor-pointer ml-0 sm:ml-0 md:ml-0 lg:ml-3`}
  //                             onClick={handlefilter}
  //                           />
  //                         </div>
  //                       </div>

  //                       {/* <-----timezones----> */}
  //                       {/* <select onChange={handleTimezoneChange} className="js-scrollable-block p-2  bg-[#F6F6F6] rounded-[4px] border h-[48px] border-[#170E32] w-[260px]">
  //                     {timezones.map((zone, i) => (
  //                       <option key={i} value={zone.tz}>
  //                         {zone.label}
  //                       </option>
  //                     ))}
  //                   </select> */}
  //                     </div>

  //                     <div className="flex mt-[1%] sm:mt-[1%] md:mt-[2%] lg:mt-[2%] xl:mt-0 ml-0 lg:ml-0 xl:ml-0 flex-col sm:flex-col md:flex-row lg:flex-row ">
  //                       <div
  //                         className={` ${styles.rangepicker} xl:hidden ml-0 sm:ml-0 md:ml-0  range-picker items-center  text-center flex mt-2 sm:mt-2 md:mt-2 lg:mt-2 xl:mt-0  `}
  //                       >
  //                         {/* <Space direction="vertical" size={16}>

  //                           <RangePicker
  //                             value={dateRange}
  //                             onChange={(dates, dateStrings) =>
  //                               handleDateChange(dates, dateStrings)
  //                             }
  //                             dropdownClassName={` ${styles.custom_dropdown}`}
  //                             className="text-[16px] h-[48px] w-[218px] lg:w-[218px] border-[#240d3a] border active:outline-none bg-[#F6F6F6] focus:outline-none  rounded-md placeholder-[#240d3a] custom-rangepicker focus:border-[#240d3a] focus:shadow-none    focus-within:border-[#240d3a] focus-within:shadow-none hover:border-[#240d3a] !important"
  //                           />
  //                         </Space> */}
  //                         <Space direction="vertical" size={16}>
  //                           {/* <RangePicker onChange={handleDateChange}/> */}
  //                           <RangePicker
  //                             value={dateRange}
  //                             onChange={(dates, dateStrings) =>
  //                               handleDateChange(dates, dateStrings)
  //                             }
  //                             dropdownClassName={` ${styles.custom_dropdown}`}
  //                             className="hidden sm:hidden md:flex text-[16px] h-[48px] w-[218px] lg:w-[218px] border-[#240d3a] border active:outline-none bg-[#F6F6F6] focus:outline-none  rounded-md placeholder-[#240d3a] custom-rangepicker focus:border-[#240d3a] focus:shadow-none    focus-within:border-[#240d3a] focus-within:shadow-none hover:border-[#240d3a] !important"
  //                           />
  //                         </Space>
  //                         <div className="flex gap-2 flex-row md:hidden">
  //                           <DatePicker
  //                             value={mobileStartDate}
  //                             className="h-[48px] w-[105px] border-[#240d3a] border active:outline-none bg-[#F6F6F6] focus:outline-none  rounded-md placeholder-[#240d3a] custom-rangepicker focus:border-[#240d3a] focus:shadow-none    focus-within:border-[#240d3a] focus-within:shadow-none hover:border-[#240d3a]"
  //                             onChange={(date, dateString) => {
  //                               setMobileStartDate(date);
  //                               if (date && mobileEndDate) {
  //                                 handleDateChange(
  //                                   [date, mobileEndDate],
  //                                   [
  //                                     dateString,
  //                                     mobileEndDate.format("YYYY-MM-DD"),
  //                                   ]
  //                                 );
  //                                 setDateRange([date, mobileEndDate]); // sync with desktop range
  //                               }
  //                             }}
  //                           />
  //                           <DatePicker
  //                             value={mobileEndDate}
  //                             className="h-[48px] w-[105px] border-[#240d3a] border active:outline-none bg-[#F6F6F6] focus:outline-none  rounded-md placeholder-[#240d3a] custom-rangepicker focus:border-[#240d3a] focus:shadow-none    focus-within:border-[#240d3a] focus-within:shadow-none hover:border-[#240d3a]"
  //                             onChange={(date, dateString) => {
  //                               setMobileEndDate(date);
  //                               if (mobileStartDate && date) {
  //                                 handleDateChange(
  //                                   [mobileStartDate, date],
  //                                   [
  //                                     mobileStartDate.format("YYYY-MM-DD"),
  //                                     dateString,
  //                                   ]
  //                                 );
  //                                 setDateRange([mobileStartDate, date]); // sync with desktop range
  //                               }
  //                             }}
  //                           />
  //                         </div>
  //                         <div>
  //                           <img
  //                             src={filtericondate}
  //                             alt="filter"
  //                             title="Clear All Filters"
  //                             className={`h-[40px] w-[40px] cursor-pointer ml-3 sm:ml-3 md:ml-3 lg:ml-3 xl:ml-3`}
  //                             onClick={handlefilter}
  //                           />
  //                         </div>
  //                       </div>
  //                       <div className="live_trade_div flex mt-[1%] sm:mt-0 md:mt-0">
  //                         <div className="relative mt-2 sm:mt-2 md:mt-2 lg:mt-2 xl:mt-0 inline-block  pr-2 sm:pr-2 md:px-1 lg:px-1 xl:px-3 ml-0 md:ml-2">
  //                           <button
  //                             type="button"
  //                             onClick={handletradepage}
  //                             className={`h-[46px] inline-flex items-center justify-center w-full px-4 py-2  font-medium text-[#240d3a] border rounded-md focus:outline-none focus-visible:ring border-[#240d3a] `}
  //                           >
  //                             <img
  //                               src={live_trade_icon}
  //                               alt="trade_btn"
  //                               title="Live Trade"
  //                               className={`h-[26px] w-[30px] cursor-pointer mr-2`}
  //                               onClick={handletradepage}
  //                             />
  //                             Live Trade
  //                           </button>
  //                         </div>
  //                       </div>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           {/* <-----new code starts----> */}

  //           <div
  //             className={` ${styles.maintableuser1} flex justify-between  max-w-[100%] w-[89%] lg:w-[84%] xl:w-[89%]
  //            fixed items-center ml-0 sm:ml-0 md:ml-0 lg:ml-[6%] xl:ml-0  top-[54%] sm:top-[56%] md:top-[52%] lg:top-[31%] xl:top-[24%]`}
  //           >
  //             {/* <div ref={dropdownRef} className="relative w-[260px] text-[13px]">

  //               <div onClick={() => setIsOpen1(!isOpen1)} className=" p-2 cursor-pointer select-none">
  //                 {selectedZone.label.match(/\(GMT[^\)]+\)/)?.[0]}
  //               </div>
  //               {isOpen1 && (
  //                 <div className="absolute mt-1 w-full max-h-[200px] overflow-y-auto bg-[#f7f3f3] shadow-md text-black z-10">
  //                   {timezones.map((zone, i) => (
  //                     <div
  //                       key={i}
  //                       onClick={() => handleSelect(zone)}
  //                       className="p-2 hover:bg-[#ebe7e7] cursor-pointer"
  //                     >
  //                       {zone.label}
  //                     </div>
  //                   ))}
  //                 </div>
  //               )}
  //             </div> */}

  //             <div className={`flex justify-center items-center`}>
  //               <div className="relative  xl:mt-0 flex justify-center items-center pr-2 sm:pr-2 md:pr-0">
  //                 {showCompareCheckboxes ? (
  //                   <button
  //                     type="button"
  //                     onClick={compare_btn}
  //                     className={`animate-bounceY transition-all duration-300  h-[46px] underline inline-flex items-center justify-center w-full py-2  font-medium text-[#240d3a]  rounded-md focus:outline-none focus-visible:ring border-[#240d3a] `}
  //                   >
  //                     Compare
  //                   </button>
  //                 ) : (
  //                   <button
  //                     type="button"
  //                     onClick={compare_btn}
  //                     className={`h-[46px] w-[110px] sm:w-[110px] md:w-[170px] underline inline-flex items-center justify-center py-2  font-medium text-[#240d3a]  rounded-md focus:outline-none focus-visible:ring border-[#240d3a] `}
  //                   >
  //                     Compare Events
  //                   </button>
  //                 )}

  //                 <img
  //                   src={empty_checkbox}
  //                   alt="empty_checkbox"
  //                   title="Delete checkbox selections"
  //                   className={`h-[16px] w-[18px] cursor-pointer ml-1 mr-2`}
  //                   onClick={empty_checkbox_selected}
  //                 />
  //               </div>
  //               {/* <div className="flex mr-4">
  //                 <h1 className="text-end flex items-center ">
  //                   <MdDateRange />


  //                   {maindata && maindata.length > 0 ? (
  //                     checkNext7daysRange === true ||
  //                     checkDatesRange === true ? (
  //                       <span className="text-[14px] font-bold text-[#5a2989] ml-2">
  //                         {`${maindata[0].date}  to  ${
  //                           maindata[maindata.length - 1].date
  //                         }`}

  //                       </span>
  //                     ) : (
  //                       <span className="text-[14px] font-bold text-[#5a2989] ml-2">
  //                         {maindata[0].date}
  //                       </span>
  //                     )
  //                   ) : (
  //                     <span className="text-[14px] font-bold text-[#5a2989] ml-2">
  //                       No dates available
  //                     </span>
  //                   )}
  //                 </h1>
  //               </div> */}
  //             </div>

  //             {/* <---today new code---> */}

  //             <div className="flex justify-end w-full items-center">
  //               {/* <div className="w-[260px] text-[13px]">

  //               <select
  //                 id="timezone-select"
  //                 value={selectedZone.tz}
  //                 onChange={handleSelect}
  //                 className="w-full p-2 bg-white border border-gray-300 rounded text-black"
  //               >
  //                 {timezones.map((zone, i) => (
  //                   <option key={i} value={zone.tz}>
  //                     {zone.label}
  //                   </option>
  //                 ))}
  //               </select>
  //             </div> */}
  //               <div className="relative inline-block px-0 sm:px-0 md:px-0 lg:px-3 xl:px-3">
  //                 <Space
  //                   style={{ width: "100%" }}
  //                   direction="vertical"
  //                   className="z-[999] "
  //                 >
  //                   <Select
  //                     id="timezone-select"
  //                     mode="single"
  //                     allowClear
  //                     value={selectedZone?.label}
  //                     onChange={handleSelect}
  //                     placeholder={
  //                       <span style={{ color: "#240d3a", fontSize: "16px" }}>
  //                         Selected Time
  //                       </span>
  //                     }
  //                     style={{
  //                       // width: "218px",
  //                       height: "24px",
  //                       backgroundColor: "#F6F6F6",
  //                       border: "1px solid #240d3a",
  //                       borderRadius: "4px",
  //                     }}
  //                     className="z-[999] custom-select overflow-visible w-[130px] sm:w-[130px] md:w-[218px]"
  //                     dropdownStyle={{
  //                       maxHeight: "800px",
  //                       overflowY: "auto",
  //                     }}
  //                     getPopupContainer={(triggerNode) => document.body}
  //                     suffixIcon={
  //                       <DownOutlined
  //                         style={{
  //                           fontSize: "14px",
  //                           color: "#240d3a",
  //                         }}
  //                       />
  //                     }
  //                     maxTagCount={1}
  //                     maxTagTextLength={20}
  //                   >
  //                     {timezones.map((zone, i) => (
  //                       <Option key={i} value={zone.label}>
  //                         {zone.label}
  //                       </Option>
  //                     ))}
  //                   </Select>
  //                 </Space>
  //               </div>

  //               <div className="flex mr-4">
  //                 <h1 className="text-end flex items-center ">
  //                   <MdDateRange />

  //                   {maindata && maindata.length > 0 ? (
  //                     checkNext7daysRange === true ||
  //                     checkDatesRange === true ? (
  //                       <span className="text-[14px] font-bold text-[#5a2989] ml-2">
  //                         {`${maindata[0].date}  to  ${
  //                           maindata[maindata.length - 1].date
  //                         }`}
  //                       </span>
  //                     ) : (
  //                       <span className="text-[14px] font-bold text-[#5a2989] ml-2">
  //                         {maindata[0].date}
  //                       </span>
  //                     )
  //                   ) : (
  //                     <span className="text-[14px] font-bold text-[#5a2989] ml-2">
  //                       No dates available
  //                     </span>
  //                   )}
  //                 </h1>
  //               </div>
  //             </div>
  //           </div>
  //           {loadingFrontpage ? (
  //             <>
  //               <div
  //                 className={`   max-w-[100%] w-[89%] lg:w-[84%] xl:w-[89%]
  //            fixed ml-0 sm:ml-0 md:ml-0 lg:ml-[0%] xl:ml-0  top-[67%] sm:top-[70%] md:top-[75%] lg:top-[42%] xl:top-[40%] flex items-center justify-center`}
  //               >
  //                 <div className="">
  //                   <img
  //                     src={loaderGif}
  //                     alt="Loading..."
  //                     height="100"
  //                     width="100"
  //                     className=""
  //                   />
  //                 </div>
  //               </div>
  //             </>
  //           ) : (
  //             <>
  //               <div className={` fixed overflow-auto`}>
  //                 <UserTable
  //                   clickedon={clickedon}
  //                   maindata={maindata}
  //                   hideEstimate={hideEstimate}
  //                   selectedCountry={selectedCountry}
  //                   selectedImpacts={selectedImpacts}
  //                   isOpen={isOpen}
  //                   onSelectionChange={handleSelectedIdString}
  //                   FinalselectedCountry={handleCountry}
  //                   FinalselectedDate={handleDate}
  //                   FinalselectedTime={handleTime}
  //                   showCompareCheckboxes={showCompareCheckboxes}
  //                   resetCheckboxes={resetCheckboxes}
  //                   // selectedZone = {selectedZone}
  //                 />
  //               </div>
  //             </>
  //           )}
  //         </div>
  //       </div>
  //     </div>

  //     <div>
  //       {modalShow && (
  //         <div
  //           id="popup-modal"
  //           className="fixed top-0 right-0 bottom-0 left-0 flex justify-center items-center bg-black bg-opacity-15 z-50"
  //           onClick={() => setModalshow(!modalShow)}
  //         >
  //           <div className="relative p-4 w-full max-w-md">
  //             <div className="relative bg-white rounded-lg shadow">
  //               <img
  //                 src={logout_eye_btn}
  //                 alt="logout_eye_btn"
  //                 className="h-[33px] w-[33px] absolute top-[12%] left-[47%]"
  //               />
  //               <div className="p-4 md:p-5 text-center">
  //                 {/* <div className="flex justify-center items-center mt-5">
  //                                  <CiCircleInfo size={40} color='grayZ'/>
  //                               </div> */}

  //                 <h3 className="mb-5 mt-[15%] text-lg font-bold text-black">
  //                   Are you sure you want to refresh the page? This action will
  //                   clear all locally stored data.
  //                 </h3>
  //                 <div className="flex items-center justify-center">
  //                   <button
  //                     data-modal-hide="popup-modal"
  //                     type="button"
  //                     className="text-[#240D3A]  bg-[#ecebeb] mt-3 font-medium rounded-lg  inline-flex items-center justify-center px-3 py-2 w-[20%]"
  //                     onClick={handleRefresh}
  //                   >
  //                     Yes
  //                   </button>
  //                   <button
  //                     data-modal-hide="popup-modal"
  //                     type="button"
  //                     className="ml-4 text-white  bg-[#240D3A] mt-3 font-medium rounded-lg  inline-flex items-center justify-center px-3 py-2 w-[20%]"
  //                     onClick={() => setModalshow(!modalShow)}
  //                   >
  //                     No
  //                   </button>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   </div>
  // );

  return (
    <div className="relative min-h-screen w-full bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 overflow-x-hidden">
      {/* Animated Background Blobs */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        <div className="blob blob-1 absolute top-0 -left-4 w-72 h-72 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob" />
        <div className="blob blob-2 absolute top-0 -right-4 w-72 h-72 bg-indigo-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000" />
        <div className="blob blob-3 absolute -bottom-8 left-20 w-72 h-72 bg-pink-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000" />
      </div>

      <div className="relative z-10">
        <div>
          <UserNavbar />
        </div>

        <div className="flex flex-row">
          {/* <---sidebar---> */}
          <div
            className={`${styles.sidebar_class
              } fixed h-[100vh] hidden lg:block pt-[6%] transition-all duration-400 ease-in-out cursor-pointer ${isOpen ? "min-w-[13%]" : "min-w-[5%]"
              } bg-gradient-to-b from-purple-200/90 via-indigo-200/80 to-purple-300/90 backdrop-blur-xl p-4 shadow-[0_10px_40px_rgba(99,11,184,0.15)] border-r-2 border-white/50`}
          >
            <div
              className={`${styles.savedhistorybtn} mb-4 top-[12%] fixed top:0 flex flex-col items-center justify-center w-[82px] select-none hover:scale-[1.05] transition-all duration-300 hover:drop-shadow-lg`}
              onClick={handlesaved_tradeoptions}
            >
              <img
                src={savedicon}
                alt="Saved Icon"
                className={`${isOpen ? "h-6 w-4 ml-2" : "h-6 w-5 ml-1"
                  } drop-shadow-md`}
                title="Check history of saved trade"
              />
              <h1 className="text-[14px] font-extrabold mt-2 break-words bg-gradient-to-r from-purple-700 to-indigo-700 bg-clip-text text-transparent tracking-wide">
                Trade Log
              </h1>
            </div>

            {/* Sidebar Content */}
            <div className="mt-[21vh]">
              <div
                className={`flex flex-col gap-2 ${isOpen ? "items-start" : "items-center"
                  }`}
              >
                <div className="relative px-0 mb-4 flex justify-start items-start flex-col w-full">
                  <div className="flex justify-center items-center flex-col gap-3 w-full">
                    {/* Yesterday */}
                    <div className="relative flex items-center justify-center text-center w-full group">
                      <div className="w-full">
                        <span
                          className="flex align-center justify-center text-center cursor-pointer"
                          onClick={handleYesterdayClick}
                        >
                          {clickedButton === "Yesterday" ? (
                            <img
                              src={yesterday_img_icon_active}
                              alt="yday"
                              className="h-[45px] w-[44px] drop-shadow-lg animate-pulse-soft"
                            />
                          ) : (
                            <img
                              src={yesterday_img_icon}
                              alt="yday"
                              className="h-[45px] w-[44px] opacity-90 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300"
                            />
                          )}
                        </span>
                        <button
                          type="button"
                          onClick={handleYesterdayClick}
                          className={`h-[40px] text-[14px] font-extrabold inline-flex items-center justify-center w-full pb-2 rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 ${clickedButton === "Yesterday"
                            ? "text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600 scale-105"
                            : "text-[#240d3a] hover:text-purple-600 hover:scale-105"
                            }`}
                        >
                          Yesterday
                        </button>
                      </div>
                      {clickedButton === "Yesterday" && (
                        <div className="absolute top-[37%] right-[-70%] -translate-y-1/2 w-0 h-0 border-t-[22px] border-b-[22px] border-l-[36px] border-transparent border-l-purple-300/90 drop-shadow-lg animate-fade-in" />
                      )}
                    </div>

                    {/* Today */}
                    <div className="relative flex items-center justify-center text-center w-full group">
                      <div className="w-full">
                        <span
                          className="flex align-center justify-center text-center cursor-pointer"
                          onClick={handleTodayClick}
                        >
                          {clickedButton === "Today" ? (
                            <img
                              src={today_img_icon_active}
                              alt="today"
                              className="h-[40px] w-[44px] drop-shadow-lg animate-pulse-soft"
                            />
                          ) : (
                            <img
                              src={today_img_icon}
                              alt="today"
                              className="h-[40px] w-[44px] opacity-90 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300"
                            />
                          )}
                        </span>
                        <button
                          type="button"
                          onClick={handleTodayClick}
                          className={`h-[40px] text-[14px] font-extrabold inline-flex items-center justify-center w-full pb-2 rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 ${clickedButton === "Today"
                            ? "text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600 scale-105"
                            : "text-[#240d3a] hover:text-purple-600 hover:scale-105"
                            }`}
                        >
                          Today
                        </button>
                        {clickedButton === "Today" && (
                          <div className="absolute top-[35%] right-[-142%] -translate-y-1/2 w-0 h-0 border-t-[22px] border-b-[22px] border-l-[36px] border-transparent border-l-purple-300/90 drop-shadow-lg animate-fade-in" />
                        )}
                      </div>
                    </div>

                    {/* Tomorrow */}
                    <div className="relative flex items-center justify-center text-center w-full group">
                      <div className="w-full">
                        <span
                          className="flex align-center justify-center text-center cursor-pointer"
                          onClick={handleTomorrowClick}
                        >
                          {clickedButton === "Tomorrow" ? (
                            <img
                              src={tomorrow_img_icon_active}
                              alt="tomorrow"
                              className="h-[45px] w-[44px] drop-shadow-lg animate-pulse-soft"
                            />
                          ) : (
                            <img
                              src={tomorrow_img_icon}
                              alt="tomorrow"
                              className="h-[45px] w-[44px] opacity-90 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300"
                            />
                          )}
                        </span>
                        <button
                          type="button"
                          onClick={handleTomorrowClick}
                          className={`h-[40px] text-[14px] inline-flex items-center justify-center w-full pb-2 font-extrabold rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 ${clickedButton === "Tomorrow"
                            ? "text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600 scale-105"
                            : "text-[#240d3a] hover:text-purple-600 hover:scale-105"
                            }`}
                        >
                          Tomorrow
                        </button>
                        {clickedButton === "Tomorrow" && (
                          <div className="absolute top-[37%] right-[-68%] -translate-y-1/2 w-0 h-0 border-t-[22px] border-b-[22px] border-l-[36px] border-transparent border-l-purple-300/90 drop-shadow-lg animate-fade-in" />
                        )}
                      </div>
                    </div>

                    {/* Next 7 Days */}
                    <div className="relative flex items-center justify-center text-center w-full group">
                      <div className="w-full">
                        <span
                          className="flex align-center justify-center text-center cursor-pointer"
                          onClick={handleweekClick}
                        >
                          {clickedButton === "Next7Days" ? (
                            <img
                              src={next7days_img_icon_active}
                              alt="7days"
                              className="h-[45px] w-[44px] drop-shadow-lg animate-pulse-soft"
                            />
                          ) : (
                            <img
                              src={next7days_img_icon}
                              alt="7days"
                              className="h-[45px] w-[44px] opacity-90 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300"
                            />
                          )}
                        </span>
                        <button
                          type="button"
                          onClick={handleweekClick}
                          className={`h-[40px] inline-flex text-[14px] items-center justify-center w-full pb-2 font-extrabold rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 ${clickedButton === "Next7Days"
                            ? "text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600 scale-105"
                            : "text-[#240d3a] hover:text-purple-600 hover:scale-105"
                            }`}
                        >
                          Next 7 Days
                        </button>
                      </div>
                      {clickedButton === "Next7Days" && (
                        <div className="absolute top-[39%] right-[-52%] -translate-y-1/2 w-0 h-0 border-t-[22px] border-b-[22px] border-l-[36px] border-transparent border-l-purple-300/90 drop-shadow-lg animate-fade-in" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <------mobile view sidebar start ------> */}
          </div>

          {isVisible && (
            <div
              id="overlay"
              className="fixed inset-0 z-[998] bg-black/60 backdrop-blur-sm flex items-end"
              onClick={handleOverlayClick}
            >
              <div
                className={`p-4 z-[999] bg-white/95 backdrop-blur-2xl rounded-t-[24px] w-full h-[38%] flex flex-col justify-center relative transition-all duration-500 transform ease-out ${isVisible ? "translate-y-0" : "translate-y-full"
                  } shadow-[0_-16px_36px_rgba(99,11,184,0.2)] border-t-2 border-purple-200/50`}
              >
                {/* Cross Button */}
                <button
                  className="absolute top-4 right-4 text-gray-600 hover:text-purple-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 rounded-full p-1 hover:bg-purple-50 transition-all"
                  onClick={() => setIsVisible(false)}
                  aria-label="Close Modal"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2.5"
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>

                <div className="flex items-center justify-around w-full gap-3">
                  <div className="flex items-center border-2 rounded-[16px] border-purple-200/50 py-3 px-3 w-[180px] md:w-[230px] bg-white/80 backdrop-blur-sm hover:bg-purple-50/50 hover:border-purple-300 hover:shadow-md transition-all duration-300">
                    <span className="ml-2">
                      {clickedButton === "Yesterday" ? (
                        <img
                          src={yesterday_img_icon_active_m}
                          alt="yday_m"
                          className="h-[40px] w-[65px]"
                        />
                      ) : (
                        <img
                          src={yesterday_img_icon_m}
                          alt="yday_m"
                          className="h-[40px] w-[65px]"
                        />
                      )}
                    </span>
                    <button
                      type="button"
                      onClick={handleYesterdayClick}
                      className={`h-[40px] text-[16px] ml-2 inline-flex items-center justify-center w-full py-2 font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#630bb8] ${clickedButton === "Yesterday"
                        ? "text-[#630bb8]"
                        : "text-[#240d3a]"
                        }`}
                    >
                      Yesterday
                    </button>
                  </div>
                  <div className="flex items-center border-2 rounded-[14px] border-[#fff] py-3 px-2 w-[180px] md:w-[230px] bg-[#F8F8F8] hover:bg-[#F3F3F3] transition-colors">
                    <span className="ml-2">
                      {clickedButton === "Today" ? (
                        <img
                          src={today_img_icon_active_m}
                          alt="today_m"
                          className="h-[37px] w-[71px]"
                        />
                      ) : (
                        <img
                          src={today_img_icon_m}
                          alt="today_m"
                          className="h-[37px] w-[71px]"
                        />
                      )}
                    </span>

                    <button
                      type="button"
                      onClick={handleTodayClick}
                      className={`h-[40px] text-[16px] ml-5 font-bold inline-flex items-center w-full py-2 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#630bb8] ${clickedButton === "Today"
                        ? "text-[#630bb8]"
                        : "text-[#240d3a]"
                        }`}
                    >
                      Today
                    </button>
                  </div>
                </div>

                <div className="mt-6 flex items-center justify-around w-full">
                  <div className="flex items-center border-2 rounded-[14px] border-[#fff] py-3 px-2 w-[180px] md:w-[230px] bg-[#F8F8F8] hover:bg-[#F3F3F3] transition-colors">
                    <span className="ml-2">
                      {clickedButton === "Tomorrow" ? (
                        <img
                          src={tomorrow_img_icon_active_m}
                          alt="tom_m"
                          className="h-[40px] w-[65px]"
                        />
                      ) : (
                        <img
                          src={tomorrow_img_icon_m}
                          alt="tom_m"
                          className="h-[40px] w-[65px]"
                        />
                      )}
                    </span>
                    <button
                      type="button"
                      onClick={handleTomorrowClick}
                      className={`h-[40px] ml-2 text-[16px] inline-flex items-center justify-center w-full py-2 font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#630bb8] ${clickedButton === "Tomorrow"
                        ? "text-[#630bb8]"
                        : "text-[#240d3a]"
                        }`}
                    >
                      Tomorrow
                    </button>
                  </div>
                  <div className="flex items-center border-2 rounded-[14px] border-[#fff] py-3 px-2 w-[180px] md:w-[230px] bg-[#F8F8F8] hover:bg-[#F3F3F3] transition-colors">
                    <span className="ml-2">
                      {clickedButton === "Next7Days" ? (
                        <img
                          src={next7days_img_icon_active_m}
                          alt="7days_m"
                          className="h-[40px] w-[65px]"
                        />
                      ) : (
                        <img
                          src={next7days_img_icon_m}
                          alt="7days_m"
                          className="h-[40px] w-[65px]"
                        />
                      )}
                    </span>
                    <button
                      type="button"
                      onClick={handleweekClick}
                      className={`h-[40px] ml-2 inline-flex text-[16px] items-center justify-center w-full py-2 font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#630bb8] ${clickedButton === "Next7Days"
                        ? "text-[#630bb8]"
                        : "text-[#240d3a]"
                        }`}
                    >
                      Next 7 Days
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* <----main component render----> */}
          <div
            className={`transition-all duration-200 ease-in-out ml-[6%] sm:ml-[6%] md:ml-[9%] w-[93%]`}
          >
            <div>
              <div
                className={`fixed top-[5%] sm:top-[8%] md:top-[10%] ${isOpen ? "w-[80%]" : "w-[89%]"
                  }`}
              >
                <div className="z-[999] w-[100%]">
                  <div
                    className={`${styles.economiccalender} ml:0 sm:ml-0 md:ml-0 lg:ml-[6%] xl:ml-0 mt-[8%] sm:mt-[9%] md:mt-0 lg:mt-0 xl:mt-0 buttons flex flex-col items-start justify-start`}
                  >
                    <div className="flex justify-between w-full items-center">
                      <h1
                        className={`${styles.economiccalender_h1} font-extrabold text-[18px] sm:text-[20px] md:text-[27px] lg:text-[30px] xl:text-[33px] mt-4 tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-purple-700 via-indigo-600 to-purple-700 drop-shadow-sm`}
                      >
                        Economic Calendar
                      </h1>

                      <div className="flex mt-5 items-center gap-3">
                        {/* Commodity Button kept for navigation but styled to match */}
                        <button
                          onClick={handleCommodityPage}
                          className="hidden md:flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-purple-600 via-indigo-600 to-purple-700 text-white font-bold text-[14px] rounded-xl shadow-[0_8px_20px_rgba(99,11,184,0.3)] hover:shadow-[0_12px_28px_rgba(99,11,184,0.4)] hover:from-purple-700 hover:via-indigo-700 hover:to-purple-800 transform hover:scale-105 hover:-translate-y-0.5 transition-all duration-300 ease-out"
                          title="Navigate to Commodity Data"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z" />
                            <path d="M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z" />
                            <path d="M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z" />
                          </svg>
                          Commodity
                        </button>

                        <button
                          className="hidden max-[1023px]:block mt-2 hover:scale-105 transition-transform"
                          onClick={handlesaved_tradeoptions}
                          title="Saved Trades"
                        >
                          <img
                            src={savedicon}
                            alt="filter icon"
                            className="h-5 w-4 cursor-pointer"
                          />
                        </button>
                        <button
                          className="ml-2 hidden max-[1023px]:block mt-2 hover:scale-105 transition-transform"
                          onClick={toggleVisibility}
                          title="Filters"
                        >
                          <img
                            src={filter_icon}
                            alt="filter icon"
                            className="h-[24px] w-[24px] cursor-pointer"
                          />
                        </button>
                      </div>
                    </div>

                    {/* Filters row */}
                    <div
                      className={`${styles.saved_haeder6} w-full first-div flex flex-col sm:flex-col md:flex-col lg:flex-col xl:flex-row mt-[1%] justify-between`}
                    >
                      <div className="flex flex-col sm:flex-col md:flex-col lg:flex-row xl:flex-row gap-3">
                        {/* Country */}
                        <div className="relative block sm:block md:inline-block lg:inline-block xl:inline-block pr-3 sm:pr-0 mb-4 sm:mb-4 md:mb-4 lg:mb-0 xl:mb-0 z-[999]">
                          <Space
                            style={{ width: "100%" }}
                            direction="vertical"
                            className="z-[999]"
                          >
                            <Select
                              mode="multiple"
                              allowClear
                              style={{
                                width: "218px",
                                height: "40px",
                                maxHeight: "40px",
                                backgroundColor: "rgba(255,255,255,0.9)",
                                border: "2px solid #7c3aed",
                                borderRadius: "14px",
                                fontWeight: "600",
                              }}
                              placeholder={
                                <span
                                  style={{ color: "#a855f7", fontSize: "16px", fontWeight: "600" }}
                                >
                                  Country
                                </span>
                              }
                              onChange={handleCountryChange}
                              value={selectedCountry}
                              getPopupContainer={(triggerNode) => document.body}
                              className="z-[999] custom-select overflow-visible hover:shadow-lg hover:border-purple-600 focus-within:shadow-xl transition-all duration-300"
                              dropdownStyle={{
                                maxHeight: "800px",
                                overflowY: "auto",
                              }}
                              suffixIcon={
                                <DownOutlined
                                  style={{ fontSize: "14px", color: "#7c3aed" }}
                                />
                              }
                              maxTagCount={1}
                              maxTagTextLength={20}
                            >
                              <Option value="AU">Australia (AU)</Option>
                              <Option value="CA">Canada (CA)</Option>
                              <Option value="EU">Europe (EU)</Option>
                              <Option value="FR">France (FR)</Option>
                              <Option value="DE">Germany (DE)</Option>
                              <Option value="IT">Italy (IT)</Option>
                              <Option value="JP">Japan (JP)</Option>
                              <Option value="NZ">New Zealand (NZ)</Option>
                              <Option value="CH">Switzerland (CH)</Option>
                              <Option value="UK">United Kingdom (UK)</Option>
                              <Option value="US">United States (US)</Option>
                            </Select>
                          </Space>
                        </div>

                        {/* Impact */}
                        <div className="relative inline-block px-0 sm:px-0 md:px-0 lg:px-3 xl:px-3">
                          <Space
                            style={{ width: "100%" }}
                            direction="vertical"
                            className="z-[999]"
                          >
                            <Select
                              mode="multiple"
                              allowClear
                              style={{
                                width: "218px",
                                height: "40px",
                                maxHeight: "40px",
                                backgroundColor: "rgba(255,255,255,0.9)",
                                border: "2px solid #7c3aed",
                                borderRadius: "14px",
                                fontWeight: "600",
                              }}
                              placeholder={
                                <span
                                  style={{ color: "#a855f7", fontSize: "16px", fontWeight: "600" }}
                                >
                                  Volatility Impact
                                </span>
                              }
                              onChange={handleImpactChange}
                              value={selectedImpacts}
                              getPopupContainer={(triggerNode) => document.body}
                              className="z-[999] custom-select overflow-visible hover:shadow-lg hover:border-purple-600 focus-within:shadow-xl transition-all duration-300"
                              dropdownStyle={{
                                maxHeight: "800px",
                                overflowY: "auto",
                              }}
                              suffixIcon={
                                <DownOutlined
                                  style={{ fontSize: "14px", color: "#7c3aed" }}
                                />
                              }
                              maxTagCount={1}
                              maxTagTextLength={20}
                            >
                              <Option value="High">High</Option>
                              <Option value="Medium">Medium</Option>
                              <Option value="Low">Low</Option>
                            </Select>
                          </Space>
                        </div>

                        {/* Search */}
                        <div
                          className={`${styles.search_economiccalender} w-[280px] h-[46px] relative flex items-center`}
                        >
                          <input
                            type="text"
                            placeholder="Search Events"
                            className="rounded-l-[14px] placeholder-purple-400 pl-5 bg-white/90 backdrop-blur-sm h-[40px] w-[63%] sm:w-[50%] md:w-[218px] lg:w-[218px] xl:w-[218px] p-1 border-2 border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent font-semibold text-[#240D3A] transition-all"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyDown={handlePressEnter}
                          />
                          <button
                            className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-3 rounded-r-[14px] h-[40px] flex items-center justify-center border-2 border-purple-600 hover:from-purple-700 hover:to-indigo-700 active:scale-[0.98] transition-all shadow-md hover:shadow-lg"
                            onClick={getSerchresult}
                            title="Search"
                          >
                            <FaSearch className="text-lg" />
                          </button>
                        </div>

                        {/* Desktop Range Picker */}
                        <div
                          className={`${styles.rangepicker} hidden xl:flex justify-center range-picker items-center text-center mt-2 sm:mt-2 md:mt-4 lg:mt-[-4px] xl:mt-[-4px] ml-[-24px] sm:ml-[-24px] md:ml-[-2%] lg:ml-0 xl:ml-0 pl-6 md:pl-6 w-[30vw] sm:w-[30vw] md:w-full`}
                          style={{ height: "56px" }}
                        >
                          <Space direction="vertical" size={16}>
                            <RangePicker
                              value={dateRange}
                              onChange={(dates, dateStrings) =>
                                handleDateChange(dates, dateStrings)
                              }
                              dropdownClassName={`${styles.custom_dropdown}`}
                              className="text-[16px] h-[40px] w-[218px] lg:w-[218px] border-2 border-purple-500 bg-white/90 backdrop-blur-sm rounded-[14px] placeholder-purple-400 custom-rangepicker focus:border-purple-600 hover:border-purple-600 hover:shadow-md transition-all font-semibold"
                            />
                          </Space>
                          <div>
                            <img
                              src={filtericondate}
                              alt="filter"
                              title="Clear All Filters"
                              className="h-[40px] w-[40px] cursor-pointer ml-0 sm:ml-0 md:ml-0 lg:ml-3 hover:rotate-6 transition-transform"
                              onClick={handlefilter}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Right controls */}
                      <div className="flex mt-[1%] sm:mt-[1%] md:mt-[2%] lg:mt-[2%] xl:mt-0 ml-0 lg:ml-0 xl:ml-0 flex-col sm:flex-col md:flex-row lg:flex-row gap-3">
                        {/* Mobile Range Picker */}
                        <div
                          className={`${styles.rangepicker} xl:hidden ml-0 sm:ml-0 md:ml-0 range-picker items-center text-center flex mt-2 sm:mt-2 md:mt-2 lg:mt-2 xl:mt-0`}
                        >
                          <Space direction="vertical" size={16}>
                            <RangePicker
                              value={dateRange}
                              onChange={(dates, dateStrings) =>
                                handleDateChange(dates, dateStrings)
                              }
                              dropdownClassName={`${styles.custom_dropdown}`}
                              className="hidden sm:hidden md:flex text-[16px] h-[48px] w-[218px] lg:w-[218px] border-[#240d3a] border bg-[#F6F6F6] rounded-[10px] placeholder-[#240d3a] custom-rangepicker"
                            />
                          </Space>
                          <div className="flex gap-2 flex-row md:hidden">
                            <DatePicker
                              value={mobileStartDate}
                              className="h-[48px] w-[105px] border-[#240d3a] border bg-[#F6F6F6] rounded-[10px] placeholder-[#240d3a] custom-rangepicker"
                              onChange={(date, dateString) => {
                                setMobileStartDate(date);
                                if (date && mobileEndDate) {
                                  handleDateChange(
                                    [date, mobileEndDate],
                                    [
                                      dateString,
                                      mobileEndDate.format("YYYY-MM-DD"),
                                    ]
                                  );
                                  setDateRange([date, mobileEndDate]);
                                }
                              }}
                            />
                            <DatePicker
                              value={mobileEndDate}
                              className="h-[48px] w-[105px] border-[#240d3a] border bg-[#F6F6F6] rounded-[10px] placeholder-[#240d3a] custom-rangepicker"
                              onChange={(date, dateString) => {
                                setMobileEndDate(date);
                                if (mobileStartDate && date) {
                                  handleDateChange(
                                    [mobileStartDate, date],
                                    [
                                      mobileStartDate.format("YYYY-MM-DD"),
                                      dateString,
                                    ]
                                  );
                                  setDateRange([mobileStartDate, date]);
                                }
                              }}
                            />
                          </div>
                          <div>
                            <img
                              src={filtericondate}
                              alt="filter"
                              title="Clear All Filters"
                              className="h-[40px] w-[40px] cursor-pointer ml-3 hover:rotate-6 transition-transform"
                              onClick={handlefilter}
                            />
                          </div>
                        </div>

                        {/* Live Trade */}
                        <div className="live_trade_div flex mt-[1%] sm:mt-0 md:mt-0">
                          <div className="relative mt-2 sm:mt-2 md:mt-2 lg:mt-2 xl:mt-0 inline-block pr-2 sm:pr-2 md:px-1 lg:px-1 xl:px-3 ml-0 md:ml-2">
                            <button
                              type="button"
                              onClick={handletradepage}
                              className="h-[40px] inline-flex items-center justify-center w-full px-5 py-2.5 font-bold text-purple-700 border-2 rounded-[14px] focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 border-purple-500 hover:shadow-lg hover:bg-purple-50 active:scale-[0.98] transition-all bg-white/95 backdrop-blur-sm"
                            >
                              <img
                                src={live_trade_icon}
                                alt="trade_btn"
                                title="Live Trade"
                                className="h-[26px] w-[30px] cursor-pointer mr-2"
                                onClick={handletradepage}
                              />
                              Live Trade
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Sub-toolbar */}
                    <div
                      className={`${styles.maintableuser1} flex justify-between max-w-[100%] w-[89%] lg:w-[84%] xl:w-[89%] fixed items-center ml-0 sm:ml-0 md:ml-0 lg:ml-[6%] xl:ml-0 top-[54%] sm:top-[56%] md:top-[52%] lg:top-[31%] xl:top-[24%]`}
                    >
                      <div className="flex items-center">
                        <div className="relative xl:mt-0 flex items-center pr-2 sm:pr-2 md:pr-0">
                          {showCompareCheckboxes ? (
                            <button
                              type="button"
                              onClick={compare_btn}
                              className="animate-bounceY transition-all duration-300 h-[46px] underline inline-flex items-center justify-center w-full py-2 font-medium text-[#240d3a] rounded-[10px] focus:outline-none focus-visible:ring border-[#240d3a] bg-white/90 hover:shadow-sm"
                            >
                              Compare
                            </button>
                          ) : (
                            <button
                              type="button"
                              onClick={compare_btn}
                              className="h-[46px] w-[110px] sm:w-[110px] md:w-[170px] underline inline-flex items-center justify-center py-2 font-medium text-[#240d3a] rounded-[10px] focus:outline-none focus-visible:ring border-[#240d3a] bg-white/90 hover:shadow-sm"
                            >
                              Compare Events
                            </button>
                          )}

                          <img
                            src={empty_checkbox}
                            alt="empty_checkbox"
                            title="Delete checkbox selections"
                            className="h-[16px] w-[18px] cursor-pointer ml-1 mr-2 hover:scale-110 transition-transform"
                            onClick={empty_checkbox_selected}
                          />
                        </div>
                      </div>

                      {/* Right side mini controls */}
                      <div className="flex justify-end w-full items-center gap-3">
                        {/* Timezone select */}
                        <div className="relative inline-block px-0 sm:px-0 md:px-0 lg:px-3 xl:px-3">
                          <Space
                            style={{ width: "100%" }}
                            direction="vertical"
                            className="z-[999]"
                          >
                            <Select
                              id="timezone-select"
                              mode="single"
                              allowClear
                              value={selectedZone?.label}
                              onChange={handleSelect}
                              placeholder={
                                <span
                                  style={{ color: "#240d3a", fontSize: "16px" }}
                                >
                                  Selected Time
                                </span>
                              }
                              style={{
                                height: "24px",
                                backgroundColor: "#F6F6F6",
                                border: "1px solid #240d3a",
                                borderRadius: "10px",
                              }}
                              className="z-[999] custom-select overflow-visible w-[130px] sm:w-[130px] md:w-[218px] hover:shadow-sm transition-shadow"
                              dropdownStyle={{
                                maxHeight: "800px",
                                overflowY: "auto",
                              }}
                              getPopupContainer={(triggerNode) => document.body}
                              suffixIcon={
                                <DownOutlined
                                  style={{ fontSize: "14px", color: "#240d3a" }}
                                />
                              }
                              maxTagCount={1}
                              maxTagTextLength={20}
                            >
                              {timezones.map((zone, i) => (
                                <Option key={i} value={zone.label}>
                                  {zone.label}
                                </Option>
                              ))}
                            </Select>
                          </Space>
                        </div>

                        {/* Date display */}
                        <div className="flex mr-4">
                          <h1 className="text-end flex items-center">
                            <MdDateRange />
                            {maindata && maindata.length > 0 ? (
                              checkNext7daysRange === true ||
                                checkDatesRange === true ? (
                                <span className="text-[14px] font-bold text-[#5a2989] ml-2">
                                  {`${maindata[0].date}  to  ${maindata[maindata.length - 1].date
                                    }`}
                                </span>
                              ) : (
                                <span className="text-[14px] font-bold text-[#5a2989] ml-2">
                                  {maindata[0].date}
                                </span>
                              )
                            ) : (
                              <span className="text-[14px] font-bold text-[#5a2989] ml-2">
                                No dates available
                              </span>
                            )}
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              {loadingFrontpage ? (
                <div
                  className={`max-w-[100%] w-[89%] lg:w-[84%] xl:w-[89%]
fixed ml-0 sm:ml-0 md:ml-0 lg:ml-[0%] xl:ml-0 top-[67%] sm:top-[70%] md:top-[75%] lg:top-[42%] xl:top-[40%]
flex flex-col items-center justify-center space-y-3`}
                  role="status"
                  aria-live="polite"
                >
                  <img
                    src={loaderGif}
                    alt="Loading economic events"
                    height="100"
                    width="100"
                    className="drop-shadow-sm"
                  />
                  <p className="text-[#240D3A] font-semibold tracking-wide">
                    Loading economic events…
                  </p>
                  {/* optional subtext; remove if not needed */}
                  <p className="text-[#5a2989] text-xs opacity-80">
                    Fetching latest calendar data
                  </p>
                </div>


              ) : (
                <div className="relative overflow-auto z-[5] mt-[18%] sm:mt-[20%] md:mt-[15%] lg:mt-[6%] xl:mt-[3%] pb-[4rem]">
                  <UserTable
                    clickedon={clickedon}
                    maindata={maindata}
                    hideEstimate={hideEstimate}
                    selectedCountry={selectedCountry}
                    selectedImpacts={selectedImpacts}
                    isOpen={isOpen}
                    onSelectionChange={handleSelectedIdString}
                    FinalselectedCountry={handleCountry}
                    FinalselectedDate={handleDate}
                    FinalselectedTime={handleTime}
                    showCompareCheckboxes={showCompareCheckboxes}
                    resetCheckboxes={resetCheckboxes}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Refresh confirm modal */}
      <div>
        {modalShow && (
          <div
            id="popup-modal"
            className="fixed inset-0 flex justify-center items-center bg-black/15 z-50"
            onClick={() => setModalshow(!modalShow)}
          >
            <div className="relative p-4 w-full max-w-md">
              <div className="relative bg-white rounded-xl shadow-[0_12px_30px_rgba(0,0,0,0.12)] border border-[#f2f2f2]">
                <img
                  src={logout_eye_btn}
                  alt="logout_eye_btn"
                  className="h-[33px] w-[33px] absolute top-[12%] left-1/2 -translate-x-1/2"
                />
                <div className="p-4 md:p-5 text-center">
                  <h3 className="mb-5 mt-[15%] text-lg font-bold text-black">
                    Are you sure you want to refresh the page? This action will
                    clear all locally stored data.
                  </h3>
                  <div className="flex items-center justify-center gap-4">
                    <button
                      data-modal-hide="popup-modal"
                      type="button"
                      className="text-[#240D3A] bg-[#ecebeb] mt-3 font-medium rounded-lg inline-flex items-center justify-center px-3 py-2 w-[20%] hover:opacity-90 active:scale-[0.99] transition-all"
                      onClick={handleRefresh}
                    >
                      Yes
                    </button>
                    <button
                      data-modal-hide="popup-modal"
                      type="button"
                      className="ml-0 text-white bg-[#240D3A] mt-3 font-medium rounded-lg inline-flex items-center justify-center px-3 py-2 w-[20%] hover:opacity-95 active:scale-[0.99] transition-all"
                      onClick={() => setModalshow(!modalShow)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );


};

export default UserCalender;
